import config from 'config';
import { applyMiddleware, compose, createStore, type UnknownAction } from 'redux';
import { type ThunkDispatch, thunk } from 'redux-thunk';

import { trialReportCardMiddleware } from '../components/TrialReportCard/trialReportCard.middleware';
import rootReducer, { type StoreType } from '../reducers';

export type AppDispatch = ThunkDispatch<StoreType, unknown, UnknownAction>;

const composeEnhancers =
	config.extensions.useReduxDevExtension &&
	typeof window === 'object' &&
	window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
		? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
		: compose;

const enhancer = composeEnhancers(applyMiddleware(thunk, trialReportCardMiddleware));

const store = createStore(rootReducer, enhancer);

export default store;
